import { Component } from '@angular/core';
import { PopupComponent } from '../../../dialogs/components/popup/popup.component';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { DialogStateService } from '../../../dialogs/services/dialog-state.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ab-session-expiry-popup',
  templateUrl: './session-expiry-popup.component.html',
  styleUrls: ['./session-expiry-popup.component.scss']
})
export class SessionExpiryPopupComponent extends PopupComponent {
  constructor(
    dialog: MatLegacyDialog,
    dialogStateService: DialogStateService,
    router: Router
  ) {
    super(dialog, dialogStateService, router);
  }
}
